module.exports = __webpack_public_path__ + "img/comment.a22d3823.svg";